/**
 * to make equipment family train case
 * @param text
 * @returns
 */
export const capitalizeText = (text) => {
    return text
        .toLowerCase()
        .replace(/(\b[a-z](?!\s))/g, (letter) => letter.toUpperCase());
};
export const getFamilyName = (modal, name) => {
    return name?.replace(modal, '')?.trim() ?? name;
};
